export default __webpack_public_path__ + "static/media/MeineVision.0f55a849.jpeg";